import {FC,ReactNode } from "react"
import {
  Popover,
  Typography,
} from "@mui/material"

type PoperOriginTypeVertical = "top" | "center" | "bottom"
type PoperOriginTypeHorizontal = "left" | "center" | "right"
type PoperTransformOriginTypeVertical = "top" | "center" | "bottom" 
type PoperTransformOriginTypeHorizontal = "left" | "center" | "right"

export const TipsPopover: FC<{
  open:boolean,
  anchorEl:HTMLElement,
  children?:ReactNode,
  onClose?:()=>void,
  anchorOrigin?:{ vertical: PoperOriginTypeVertical, horizontal: PoperOriginTypeHorizontal },
  transformOrigin?:{ vertical: PoperTransformOriginTypeVertical, horizontal: PoperTransformOriginTypeHorizontal },
}>= (props: any) => {
  return <Popover
    open={props.open}
    anchorEl={props.anchorEl}
    onClose={props.onClose??(()=>{})}
    anchorOrigin={props.anchorOrigin??{ vertical: "center", horizontal: "left" }}
    transformOrigin={props.transformOrigin??{ vertical: "center", horizontal: "right" }}
    sx={{
          position: 'absolute',
          left:'-15px',
          '& .MuiPaper-root': {
            borderRadius: '8px',
            color: '#fff',
            backgroundColor: '#616161ff',
            transition: 'opacity 0.3s',
            width: '280px',
            overflow: 'visible',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: '50%',
              right: '-8px',
              transform: 'translateY(-50%) rotate(45deg)',
              width: '16px',
              height: '16px',
              backgroundColor: '#616161ff',
              // boxShadow: '-4px 4px 8px rgba(0, 0, 0, 0.1)',
              zIndex: 1,
            }
          }
      }}
  >
     {props.children??<Typography sx={{p:2}} variant="body2">You may add you content here.</Typography>}
  </Popover>
}